// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file user/v1/user.proto (package user.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user/v1/user.proto.
 */
export const file_user_v1_user: GenFile = /*@__PURE__*/
  fileDesc("ChJ1c2VyL3YxL3VzZXIucHJvdG8SB3VzZXIudjEiiQEKBFVzZXISCgoCaWQYASABKAkSEwoLcHJvdmlkZXJfaWQYAiABKAkSHwoEa2luZBgDIAEoDjIRLnVzZXIudjEuVXNlcktpbmQSDQoFZW1haWwYBCABKAkSDAoEbmFtZRgFIAEoCRINCgVyb2xlcxgGIAMoCRITCgtwaWN0dXJlX3VybBgHIAEoCSIOCgxHZXRNZVJlcXVlc3QiLAoNR2V0TWVSZXNwb25zZRIbCgR1c2VyGAEgASgLMg0udXNlci52MS5Vc2VyIg8KDUxvZ291dFJlcXVlc3QiEAoOTG9nb3V0UmVzcG9uc2UiIAoMTG9naW5SZXF1ZXN0EhAKCGlkX3Rva2VuGAEgASgJIkMKDUxvZ2luUmVzcG9uc2USGwoEdXNlchgBIAEoCzINLnVzZXIudjEuVXNlchIVCg1zZXNzaW9uX3Rva2VuGAIgASgJKlUKCFVzZXJLaW5kEhkKFVVTRVJfS0lORF9VTlNQRUNJRklFRBAAEhYKElVTRVJfS0lORF9DVVNUT01FUhABEhYKElVTRVJfS0lORF9QTEFURk9STRACMr4BCgtVc2VyU2VydmljZRI4CgVMb2dpbhIVLnVzZXIudjEuTG9naW5SZXF1ZXN0GhYudXNlci52MS5Mb2dpblJlc3BvbnNlIgASOAoFR2V0TWUSFS51c2VyLnYxLkdldE1lUmVxdWVzdBoWLnVzZXIudjEuR2V0TWVSZXNwb25zZSIAEjsKBkxvZ291dBIWLnVzZXIudjEuTG9nb3V0UmVxdWVzdBoXLnVzZXIudjEuTG9nb3V0UmVzcG9uc2UiAEI4WjZnaXRodWIuY29tL3RoZXRyZWVwL2E2dHIvYmFja2VuZC9nZW4vZ28vdXNlci92MTt1c2VydjFiBnByb3RvMw");

/**
 * User - the authenticated user.
 *
 * @generated from message user.v1.User
 */
export type User = Message<"user.v1.User"> & {
  /**
   * Unique identifier of the user.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Identity provider the user signed in with.
   *
   * @generated from field: string provider_id = 2;
   */
  providerId: string;

  /**
   * Customer or platform user.
   *
   * @generated from field: user.v1.UserKind kind = 3;
   */
  kind: UserKind;

  /**
   * Email address as asserted by the identity provider.
   *
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * Display name as asserted by the identity provider.
   *
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * Roles granted to the user (e.g. "agent", "platform_admin").
   *
   * @generated from field: repeated string roles = 6;
   */
  roles: string[];

  /**
   * Profile photo from the identity provider, empty when it has none.
   *
   * @generated from field: string picture_url = 7;
   */
  pictureUrl: string;
};

/**
 * Describes the message user.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 0);

/**
 * GetMeRequest - request for the current user.
 *
 * @generated from message user.v1.GetMeRequest
 */
export type GetMeRequest = Message<"user.v1.GetMeRequest"> & {
};

/**
 * Describes the message user.v1.GetMeRequest.
 * Use `create(GetMeRequestSchema)` to create a new message.
 */
export const GetMeRequestSchema: GenMessage<GetMeRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 1);

/**
 * GetMeResponse - the current user.
 *
 * @generated from message user.v1.GetMeResponse
 */
export type GetMeResponse = Message<"user.v1.GetMeResponse"> & {
  /**
   * The authenticated user.
   *
   * @generated from field: user.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message user.v1.GetMeResponse.
 * Use `create(GetMeResponseSchema)` to create a new message.
 */
export const GetMeResponseSchema: GenMessage<GetMeResponse> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 2);

/**
 * LogoutRequest - request for logging out the user.
 *
 * @generated from message user.v1.LogoutRequest
 */
export type LogoutRequest = Message<"user.v1.LogoutRequest"> & {
};

/**
 * Describes the message user.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 3);

/**
 * LogoutResponse - response for logging out the user.
 *
 * @generated from message user.v1.LogoutResponse
 */
export type LogoutResponse = Message<"user.v1.LogoutResponse"> & {
};

/**
 * Describes the message user.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 4);

/**
 * LoginRequest - request for opening a session.
 *
 * @generated from message user.v1.LoginRequest
 */
export type LoginRequest = Message<"user.v1.LoginRequest"> & {
  /**
   * ID token returned by the identity broker to the browser after sign-in.
   *
   * @generated from field: string id_token = 1;
   */
  idToken: string;
};

/**
 * Describes the message user.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 5);

/**
 * LoginResponse - the opened session.
 *
 * @generated from message user.v1.LoginResponse
 */
export type LoginResponse = Message<"user.v1.LoginResponse"> & {
  /**
   * The authenticated user.
   *
   * @generated from field: user.v1.User user = 1;
   */
  user?: User;

  /**
   * Opaque session token, sent back as "Authorization: Bearer <token>" on every call.
   *
   * @generated from field: string session_token = 2;
   */
  sessionToken: string;
};

/**
 * Describes the message user.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 6);

/**
 * UserKind - whether the user belongs to a customer or operates the platform.
 *
 * @generated from enum user.v1.UserKind
 */
export enum UserKind {
  /**
   * Unknown kind.
   *
   * @generated from enum value: USER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * User authenticated through a customer identity provider (e.g. an assisteur's agents).
   *
   * @generated from enum value: USER_KIND_CUSTOMER = 1;
   */
  CUSTOMER = 1,

  /**
   * The Treep staff, authenticated through the platform identity provider.
   *
   * @generated from enum value: USER_KIND_PLATFORM = 2;
   */
  PLATFORM = 2,
}

/**
 * Describes the enum user.v1.UserKind.
 */
export const UserKindSchema: GenEnum<UserKind> = /*@__PURE__*/
  enumDesc(file_user_v1_user, 0);

/**
 * UserService - manages user session operations.
 *
 * @generated from service user.v1.UserService
 */
export const UserService: GenService<{
  /**
   * Opens a session from an ID token issued by the identity broker after sign-in.
   *
   * @generated from rpc user.v1.UserService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * Returns the user behind the current session.
   *
   * @generated from rpc user.v1.UserService.GetMe
   */
  getMe: {
    methodKind: "unary";
    input: typeof GetMeRequestSchema;
    output: typeof GetMeResponseSchema;
  },
  /**
   * Terminates the current user session and invalidates the token.
   *
   * @generated from rpc user.v1.UserService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_user_v1_user, 0);

